// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
	FILE: _core.scss

	USED ON:
		- srprs.me/*

	USAGE:
		Meant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1

	NOTES:
		NEVER use @import "base/*"; or such, read this => http://stackoverflow.com/a/4779432
*/
.clearfix {
  overflow: auto;
}

.display-flex {
  display: inline;
}
@media only screen and (min-width: 767px) {
  .display-flex {
    display: flex;
  }
}

.full-width {
  width: 100%;
}

@media only screen and (max-width: 767px) {
  .mobile-full-width {
    width: 100%;
  }
}

@media only screen and (min-width: 767px) {
  .width-49 {
    width: 49%;
  }
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.margin-b-s {
  margin-bottom: 10px;
}

.margin-b-m {
  margin-bottom: 20px;
}

.margin-b-l {
  margin-bottom: 40px;
}

.padding-t-s {
  padding-top: 10px;
}

.padding-t-s-7 {
  padding-top: 7px;
}

.padding-l-s {
  padding-left: 10px;
}

.padding-r-s {
  padding-right: 10px;
}

.padding-r-m {
  padding-right: 20px;
}

.padding-r-xl {
  padding-right: 60px;
}

.text-centered {
  text-align: center;
}

.text-bold {
  font-weight: bold;
}

.text-small {
  font-size: 14px;
}

.text-medium {
  font-size: 20px;
}

.text-large {
  font-size: 24px;
}

.text-xlarge {
  font-size: 28px;
}

.text-uppercase {
  text-transform: uppercase;
}

.is-loading,
.loading {
  color: #ececec;
  background-color: #ececec;
}
.is-loading::selection, .is-loading::-moz-selection,
.loading::selection,
.loading::-moz-selection {
  background: #ececec;
}

@media screen and (max-width: ) {
  body:before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 375px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 640px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 768px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1024px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1280px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1440px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1600px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
/*
	usage:

	.element {
		@include browserfix(ie) {
			&:after {
				content: "This is IE only"
			}
		}
		@include browserfix(firefox) {
			&:after {
				content: "Only Firefox users will see this";
			}
		}
	}
*/
@keyframes buttonDisabled {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
@keyframes tada {
  0% {
    transform: scale3d(1, 1, 1);
  }
  10%, 20% {
    transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);
  }
  30%, 50%, 70%, 90% {
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
  }
  40%, 60%, 80% {
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
  }
  100% {
    transform: scale3d(1, 1, 1);
  }
}
.tada {
  animation-name: tada;
}

.srprs-header {
  --mobileMenuPaddingLeft: 40px;
  --menuColour: #222;
  --topColour: var(--colorForegroundAccent);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 997;
  width: 100vw;
  height: 71px;
  background-color: transparent;
  transition: background-color 0.25s ease-out;
  will-change: auto;
  /* locale related stuff (the fancy dropdown) */
  /* login stuff */
  /* STATES - DON'T RE-ORDER STUFF OR ELSE I WILL CRY */
  /* states => locked when the visitor clicks the language/currency dropdown */
  /* states => is in funnel, no need to show the CTA */
  /* states => solid (solid bg after scrolling page for ~20px) */
  /* states => when the visitor clicks the hamburger */
  /* Overrides */
}
@supports (padding: max(0px)) {
  .srprs-header {
    padding-left: calc(constant(safe-area-inset-left));
    padding-right: calc(constant(safe-area-inset-right));
  }
}
.srprs-header > .wrapper-inner {
  display: flex;
  align-items: center;
}
.srprs-header .locale {
  position: relative;
  height: 36px;
  width: 96px;
  z-index: 12;
  text-transform: uppercase;
  transition: all 0.15s ease-out;
}
.srprs-header .locale .locale-dropdown {
  position: absolute;
  top: 0;
  left: 0;
  width: 96px;
  max-height: 36px;
  overflow: hidden;
  text-align: center;
  border-radius: 4px;
  transition: background-color 0.15s ease-in 0.25s, max-height 0.25s ease-out;
}
.srprs-header .locale .locale-dropdown li {
  position: relative;
  line-height: 36px;
  cursor: pointer;
  color: var(--menuColour);
}
.srprs-header .locale .locale-dropdown li a {
  color: #222;
}
.srprs-header .locale .locale-dropdown li .chevron {
  display: inline-block;
  margin-left: 4px;
  width: 12px;
  height: 100%;
}
.srprs-header .locale .locale-dropdown li .chevron:before, .srprs-header .locale .locale-dropdown li .chevron:after {
  content: "";
  position: absolute;
  top: 14px;
  border-radius: 2px;
  width: 2px;
  height: 6px;
  transition: all 0.25s ease-in-out;
  will-change: auto;
  background-color: var(--menuColour);
}
.srprs-header .locale .locale-dropdown li .chevron:before {
  transform: translate(2px, 0) rotate(45deg);
}
.srprs-header .locale .locale-dropdown li .chevron:after {
  transform: translate(-2px, 0) rotate(-45deg);
}
.srprs-header .locale .locale-dropdown li.locale-currentLanguage {
  margin-top: 4px;
  margin-bottom: 9px;
  font-weight: bold;
  font-size: 16px;
}
.srprs-header .locale .locale-dropdown li.locale-line {
  margin-top: 9px;
}
.srprs-header .locale .locale-dropdown li.locale-line:before {
  content: "";
  position: absolute;
  top: -4px;
  left: 20%;
  width: 60%;
  height: 1px;
  background-color: #e7e7e7;
}
.srprs-header .locale .locale-dropdown li.locale-currency {
  display: flex;
  justify-content: center;
  margin-top: 9px;
  margin-bottom: 12px;
}
.srprs-header .locale .locale-dropdown li.locale-currency:before {
  content: "";
  position: absolute;
  top: -4px;
  left: 20%;
  width: 60%;
  height: 1px;
  background-color: #e7e7e7;
}
.srprs-header .locale .locale-dropdown li.locale-currency a {
  padding-right: 8px;
  padding-left: 8px;
  margin-right: -4px;
  font-weight: bold;
}
.srprs-header .locale .locale-dropdown.is-open {
  box-shadow: 0 0 12px 0 rgba(34, 34, 34, 0.15);
  background-color: #fff;
  transition: background-color 0.15s ease-out 0s, max-height 0.25s ease-out;
  max-height: 340px;
}
.srprs-header .locale .locale-dropdown.is-open li span {
  color: #222;
}
.srprs-header .locale .locale-dropdown.is-open li .chevron:before, .srprs-header .locale .locale-dropdown.is-open li .chevron:after {
  background-color: #222;
}
.srprs-header .locale .locale-dropdown.is-open li .chevron:before {
  transform: translate(-2px, 0) rotate(45deg);
}
.srprs-header .locale .locale-dropdown.is-open li .chevron:after {
  transform: translate(2px, 0) rotate(-45deg);
}
.srprs-header .locale-overlay {
  transition-property: all;
  transition-duration: 0.25s;
  transition-timing-function: ease-out;
  transition-delay: 0s;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: rgba(34, 34, 34, 0.95);
  visibility: hidden;
  opacity: 0;
  user-select: none;
  z-index: 11;
}
.srprs-header .login {
  z-index: 12;
  transition: all 0.25s ease-out;
  margin-left: -10px;
}
.srprs-header .login svg {
  width: 24px;
  height: 24px;
}
.srprs-header .login svg path {
  fill: var(--menuColour);
}
.srprs-header .login .avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
.srprs-header .overlay {
  transition-property: all;
  transition-duration: 0.5s;
  transition-timing-function: ease-out;
  transition-delay: 0s;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: rgba(34, 34, 34, 0.95);
  visibility: hidden;
  opacity: 0;
  user-select: none;
  z-index: 0;
}
.srprs-header .logo {
  width: 40px;
  height: 35px;
  position: absolute;
  top: 18px;
  left: 18px;
  visibility: visible;
}
.srprs-header .logo path {
  transition: all 0.25s ease-out;
  fill: var(--topColour);
}
.srprs-header .logo .logo-bigdisplays {
  display: none;
}
.srprs-header .logo > a {
  width: 100%;
  height: 100%;
  display: inline-block;
}
.srprs-header .hamburger-wrapper {
  position: absolute;
  display: flex;
  top: 26px;
  right: 20px;
  width: 30px;
  height: 30px;
}
.srprs-header .hamburger-wrapper .hamburger {
  /* nomnomnom */
  position: absolute;
  z-index: 11;
  top: 0;
  right: 0;
  width: 30px;
  height: 30px;
  cursor: pointer;
}
.srprs-header .hamburger-wrapper .hamburger .bar {
  display: block;
  position: absolute;
  right: 0;
  top: 9px;
  width: 30px;
  height: 5px;
  margin-bottom: 4px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  background-color: var(--topColour);
}
.srprs-header .hamburger-wrapper .hamburger .bar:before, .srprs-header .hamburger-wrapper .hamburger .bar:after {
  content: "";
  position: absolute;
  right: 0;
  height: 5px;
  transform: rotate(0);
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  background-color: var(--topColour);
}
.srprs-header .hamburger-wrapper .hamburger .bar:before {
  /* 1st bar */
  top: -9px;
  width: 32px;
  transition: top 0.25s 0.25s cubic-bezier(0.23, 1, 0.32, 1), transform 0.25s cubic-bezier(0.23, 1, 0.32, 1);
}
.srprs-header .hamburger-wrapper .hamburger .bar:after {
  /* 3rd bar */
  bottom: -9px;
  width: 24px;
  transition: bottom 0.25s 0.25s cubic-bezier(0.23, 1, 0.32, 1), transform 0.25s cubic-bezier(0.23, 1, 0.32, 1);
}
.srprs-header .wrapper-mobile .wrapper-menu {
  transition-property: all;
  transition-duration: 0.25s;
  transition-timing-function: ease-out;
  transition-delay: 0s;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  z-index: 10;
  background-color: #fff;
  padding-bottom: 40px;
  visibility: hidden;
  opacity: 0;
}
.srprs-header .wrapper-mobile .wrapper-menu .wrapper-header {
  display: flex;
  height: 84px;
  color: #222;
}
.srprs-header .wrapper-mobile .wrapper-menu .wrapper-header path {
  fill: #222;
}
.srprs-header .wrapper-mobile .wrapper-menu .wrapper-header .locale {
  margin-top: 14px;
  margin-left: 10px;
}
.srprs-header .wrapper-mobile .wrapper-menu .wrapper-header .locale .locale-dropdown li {
  color: #222;
}
.srprs-header .wrapper-mobile .wrapper-menu .wrapper-header .locale .locale-dropdown .chevron:before,
.srprs-header .wrapper-mobile .wrapper-menu .wrapper-header .locale .locale-dropdown .chevron:after {
  background-color: #222;
}
.srprs-header .wrapper-mobile .wrapper-menu .wrapper-header .login {
  margin-top: 24px;
}
.srprs-header .wrapper-mobile .wrapper-menu .wrapper-content ul {
  margin-bottom: 22px;
}
.srprs-header .wrapper-mobile .wrapper-menu .wrapper-content ul li {
  transition-property: all;
  transition-duration: 0.15s;
  transition-timing-function: ease-out;
  transition-delay: 0s;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  opacity: 0;
  padding-top: 12px;
  padding-left: var(--mobileMenuPaddingLeft);
  padding-right: var(--mobileMenuPaddingLeft);
  padding-bottom: 12px;
  line-height: 20px;
  text-transform: uppercase;
  font-size: 16px;
  font-weight: normal;
  font-family: font-body, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
}
.srprs-header .wrapper-mobile .wrapper-menu .wrapper-content ul li a {
  color: #222;
}
.srprs-header .wrapper-mobile .wrapper-menu .wrapper-content ul li.is-current {
  padding-left: calc(var(--mobileMenuPaddingLeft) - 5px);
  border-left-width: 5px;
  border-left-style: solid;
  border-left-color: #222;
}
.srprs-header .wrapper-mobile .wrapper-menu .srprs-button {
  padding-left: var(--mobileMenuPaddingLeft);
  transform: translateX(-100%);
  color: #fff;
}
.srprs-header .wrapper-desktop {
  --menuColour: var(--colorForegroundAccent);
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  align-items: flex-end;
}
.srprs-header .wrapper-desktop .secure-overflow {
  position: relative;
  display: flex;
  align-items: flex-end;
  margin-right: 20px;
}
.srprs-header .wrapper-desktop .secure-overflow li {
  display: inline-block;
  text-transform: uppercase;
  font-family: font-body, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  font-weight: normal;
  font-size: 15px;
  padding-top: 70px;
  padding-right: 15px;
  padding-bottom: 0;
  padding-left: 15px;
}
.srprs-header .wrapper-desktop .secure-overflow li a {
  color: var(--menuColour);
}
.srprs-header .wrapper-desktop .secure-overflow li.is-current {
  padding-top: 62px;
  border-top-width: 8px;
  border-top-style: solid;
  border-top-color: var(--menuColour);
}
.srprs-header .wrapper-desktop .secure-overflow:after {
  transition-property: all;
  transition-duration: 0.25s;
  transition-timing-function: ease-out;
  transition-delay: 0s;
  content: "";
  position: absolute;
  bottom: -8px;
  right: -18px;
  width: 6px;
  height: 48px;
  background-color: var(--colorForegroundAccent);
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}
.srprs-header .wrapper-desktop .login {
  margin-right: 40px;
}
.srprs-header .wrapper-desktop .srprs-button {
  margin-bottom: -10px;
  transform: none;
  text-transform: capitalize;
}
.srprs-header.is-locked .login {
  z-index: 10;
}
.srprs-header.is-locked .locale-overlay {
  visibility: visible;
  opacity: 1;
}
.srprs-header.is-funnel {
  position: absolute;
}
.srprs-header.is-funnel .srprs-button {
  display: none;
}
.srprs-header.is-solid {
  --topColour: #222;
  background-color: #fff;
}
.srprs-header.is-solid .wrapper-desktop {
  --menuColour: #222;
}
.srprs-header.is-solid .wrapper-desktop .secure-overflow ul:after {
  margin-top: 0;
  background-color: #e7e7e7;
}
.srprs-header.is-solid .wrapper-desktop .secure-overflow li {
  padding-top: 25px;
}
.srprs-header.is-solid .wrapper-desktop .secure-overflow li.is-current {
  padding-top: 20px;
}
.srprs-header.is-solid .wrapper-desktop .srprs-button {
  color: #fff;
  background-color: #222;
  border-color: #222;
}
.srprs-header.is-open .overlay {
  visibility: visible;
  opacity: 1;
}
.srprs-header.is-open .wrapper-mobile {
  --topColour: #222;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu {
  visibility: visible;
  opacity: 1;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .wrapper-content ul li {
  opacity: 1;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .wrapper-content ul li:nth-child(1) {
  transition: opacity 0.15s ease-out 0.1s, transform 0.15s ease-out 0.1s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .wrapper-content ul li:nth-child(2) {
  transition: opacity 0.15s ease-out 0.2s, transform 0.15s ease-out 0.2s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .wrapper-content ul li:nth-child(3) {
  transition: opacity 0.15s ease-out 0.3s, transform 0.15s ease-out 0.3s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .wrapper-content ul li:nth-child(4) {
  transition: opacity 0.15s ease-out 0.4s, transform 0.15s ease-out 0.4s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .wrapper-content ul li:nth-child(5) {
  transition: opacity 0.15s ease-out 0.5s, transform 0.15s ease-out 0.5s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .wrapper-content ul li:nth-child(6) {
  transition: opacity 0.15s ease-out 0.6s, transform 0.15s ease-out 0.6s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .wrapper-content ul li:nth-child(7) {
  transition: opacity 0.15s ease-out 0.7s, transform 0.15s ease-out 0.7s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .wrapper-content ul li:nth-child(8) {
  transition: opacity 0.15s ease-out 0.8s, transform 0.15s ease-out 0.8s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .wrapper-content ul li:nth-child(9) {
  transition: opacity 0.15s ease-out 0.9s, transform 0.15s ease-out 0.9s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .wrapper-content ul li:nth-child(10) {
  transition: opacity 0.15s ease-out 1s, transform 0.15s ease-out 1s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .wrapper-content ul li:nth-child(11) {
  transition: opacity 0.15s ease-out 1.1s, transform 0.15s ease-out 1.1s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .wrapper-content ul li:nth-child(12) {
  transition: opacity 0.15s ease-out 1.2s, transform 0.15s ease-out 1.2s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .wrapper-content ul li:nth-child(13) {
  transition: opacity 0.15s ease-out 1.3s, transform 0.15s ease-out 1.3s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .wrapper-content ul li:nth-child(14) {
  transition: opacity 0.15s ease-out 1.4s, transform 0.15s ease-out 1.4s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .wrapper-content ul li:nth-child(15) {
  transition: opacity 0.15s ease-out 1.5s, transform 0.15s ease-out 1.5s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .wrapper-content ul li:nth-child(16) {
  transition: opacity 0.15s ease-out 1.6s, transform 0.15s ease-out 1.6s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .wrapper-content ul li:nth-child(17) {
  transition: opacity 0.15s ease-out 1.7s, transform 0.15s ease-out 1.7s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .wrapper-content ul li:nth-child(18) {
  transition: opacity 0.15s ease-out 1.8s, transform 0.15s ease-out 1.8s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .wrapper-content ul li:nth-child(19) {
  transition: opacity 0.15s ease-out 1.9s, transform 0.15s ease-out 1.9s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .srprs-button {
  transform: translateX(0);
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .srprs-button.is-followup-2 {
  transition-delay: 0.15s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .srprs-button.is-followup-3 {
  transition-delay: 0.3s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .srprs-button.is-followup-4 {
  transition-delay: 0.45s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .srprs-button.is-followup-5 {
  transition-delay: 0.6s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .srprs-button.is-followup-6 {
  transition-delay: 0.75s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .srprs-button.is-followup-7 {
  transition-delay: 0.9s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .srprs-button.is-followup-8 {
  transition-delay: 1.05s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .srprs-button.is-followup-9 {
  transition-delay: 1.2s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .srprs-button.is-followup-10 {
  transition-delay: 1.35s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .srprs-button.is-followup-11 {
  transition-delay: 1.5s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .srprs-button.is-followup-12 {
  transition-delay: 1.65s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .srprs-button.is-followup-13 {
  transition-delay: 1.8s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .srprs-button.is-followup-14 {
  transition-delay: 1.95s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .srprs-button.is-followup-15 {
  transition-delay: 2.1s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .srprs-button.is-followup-16 {
  transition-delay: 2.25s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .srprs-button.is-followup-17 {
  transition-delay: 2.4s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .srprs-button.is-followup-18 {
  transition-delay: 2.55s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .srprs-button.is-followup-19 {
  transition-delay: 2.7s;
}
.srprs-header.is-open .wrapper-mobile .wrapper-menu .srprs-button.is-followup-20 {
  transition-delay: 2.85s;
}
.srprs-header.is-open .wrapper-desktop .secure-overflow li {
  opacity: 1;
  transform: translateY(0);
}
.srprs-header.is-open .wrapper-desktop .secure-overflow li:nth-child(1) {
  transition: opacity 0.15s ease-out 0.1s, transform 0.15s ease-out 0.1s;
}
.srprs-header.is-open .wrapper-desktop .secure-overflow li:nth-child(2) {
  transition: opacity 0.15s ease-out 0.2s, transform 0.15s ease-out 0.2s;
}
.srprs-header.is-open .wrapper-desktop .secure-overflow li:nth-child(3) {
  transition: opacity 0.15s ease-out 0.3s, transform 0.15s ease-out 0.3s;
}
.srprs-header.is-open .wrapper-desktop .secure-overflow li:nth-child(4) {
  transition: opacity 0.15s ease-out 0.4s, transform 0.15s ease-out 0.4s;
}
.srprs-header.is-open .wrapper-desktop .secure-overflow li:nth-child(5) {
  transition: opacity 0.15s ease-out 0.5s, transform 0.15s ease-out 0.5s;
}
.srprs-header.is-open .wrapper-desktop .secure-overflow li:nth-child(6) {
  transition: opacity 0.15s ease-out 0.6s, transform 0.15s ease-out 0.6s;
}
.srprs-header.is-open .wrapper-desktop .secure-overflow li:nth-child(7) {
  transition: opacity 0.15s ease-out 0.7s, transform 0.15s ease-out 0.7s;
}
.srprs-header.is-open .wrapper-desktop .secure-overflow li:nth-child(8) {
  transition: opacity 0.15s ease-out 0.8s, transform 0.15s ease-out 0.8s;
}
.srprs-header.is-open .wrapper-desktop .secure-overflow li:nth-child(9) {
  transition: opacity 0.15s ease-out 0.9s, transform 0.15s ease-out 0.9s;
}
.srprs-header.is-open .wrapper-desktop .secure-overflow li:nth-child(10) {
  transition: opacity 0.15s ease-out 1s, transform 0.15s ease-out 1s;
}
.srprs-header.is-open .wrapper-desktop .secure-overflow li:nth-child(11) {
  transition: opacity 0.15s ease-out 1.1s, transform 0.15s ease-out 1.1s;
}
.srprs-header.is-open .wrapper-desktop .secure-overflow li:nth-child(12) {
  transition: opacity 0.15s ease-out 1.2s, transform 0.15s ease-out 1.2s;
}
.srprs-header.is-open .wrapper-desktop .secure-overflow li:nth-child(13) {
  transition: opacity 0.15s ease-out 1.3s, transform 0.15s ease-out 1.3s;
}
.srprs-header.is-open .wrapper-desktop .secure-overflow li:nth-child(14) {
  transition: opacity 0.15s ease-out 1.4s, transform 0.15s ease-out 1.4s;
}
.srprs-header.is-open .wrapper-desktop .secure-overflow li:nth-child(15) {
  transition: opacity 0.15s ease-out 1.5s, transform 0.15s ease-out 1.5s;
}
.srprs-header.is-open .wrapper-desktop .secure-overflow li:nth-child(16) {
  transition: opacity 0.15s ease-out 1.6s, transform 0.15s ease-out 1.6s;
}
.srprs-header.is-open .wrapper-desktop .secure-overflow li:nth-child(17) {
  transition: opacity 0.15s ease-out 1.7s, transform 0.15s ease-out 1.7s;
}
.srprs-header.is-open .wrapper-desktop .secure-overflow li:nth-child(18) {
  transition: opacity 0.15s ease-out 1.8s, transform 0.15s ease-out 1.8s;
}
.srprs-header.is-open .wrapper-desktop .secure-overflow li:nth-child(19) {
  transition: opacity 0.15s ease-out 1.9s, transform 0.15s ease-out 1.9s;
}
.srprs-header.is-open .hamburger .bar {
  background-color: transparent;
}
.srprs-header.is-open .hamburger .bar:before {
  top: 0;
  transform: rotate(45deg);
  transition: top 0.25s cubic-bezier(0.23, 1, 0.32, 1), transform 0.25s 0.25s cubic-bezier(0.23, 1, 0.32, 1);
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.srprs-header.is-open .hamburger .bar:after {
  width: 32px;
  bottom: 0;
  transform: rotate(-45deg);
  transition: bottom 0.25s cubic-bezier(0.23, 1, 0.32, 1), transform 0.25s 0.25s cubic-bezier(0.23, 1, 0.32, 1);
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.srprs-header.no-menu {
  background: none;
  position: absolute;
}
.srprs-header.no-menu .hamburger {
  display: none;
}
.srprs-header.override-black {
  --menuColour: #222;
  --topColour: #222;
}
.srprs-header.override-black .wrapper-desktop {
  --menuColour: #222;
}
.srprs-header.override-white:not(.is-solid) {
  --menuColour: #fff;
  --topColour: #fff;
}
.srprs-header.override-white:not(.is-solid) .wrapper-desktop {
  --menuColour: #fff;
}

@media screen and (min-width: 1024px) {
  .srprs-header.is-funnel {
    margin-bottom: -140px;
  }
}
@media screen and (min-width: 1280px) {
  .srprs-header {
    /* states => lightweight/funnel - disable 'book now' button (and move all other stuff to the right) + some extra styles for .is-lightweight (we like to keep stuff DRY ;)) */
    /* states => lightweight variant means "menu-items hidden behind hamburger menu, which means less distraction for the visitor */
    /* states => solid (solid bg after scrolling page for ~20px) */
    /* GENERIC STUFF */
  }
  .srprs-header .wrapper-mobile {
    display: none;
  }
  .srprs-header .wrapper-desktop {
    display: flex;
  }
  .srprs-header .wrapper-desktop .hamburger {
    visibility: hidden;
    opacity: 0;
  }
  .srprs-header.is-lightweight .hamburger, .srprs-header.is-funnel .hamburger {
    visibility: visible;
    opacity: 1;
  }
  .srprs-header.is-lightweight .secure-overflow li, .srprs-header.is-funnel .secure-overflow li {
    visibility: hidden;
    opacity: 0;
  }
  .srprs-header.is-lightweight .login, .srprs-header.is-funnel .login {
    margin-right: 50px;
    margin-left: 0;
  }
  .srprs-header.is-lightweight .hamburger-wrapper, .srprs-header.is-funnel .hamburger-wrapper {
    position: relative;
    top: 0;
    right: 0;
  }
  .srprs-header.is-lightweight.is-open .logo, .srprs-header.is-funnel.is-open .logo {
    visibility: visible;
    opacity: 1;
  }
  .srprs-header.is-lightweight.is-open .secure-overflow li, .srprs-header.is-funnel.is-open .secure-overflow li {
    visibility: visible;
    opacity: 1;
  }
  .srprs-header.is-lightweight.is-open .secure-overflow li:nth-last-child(1), .srprs-header.is-funnel.is-open .secure-overflow li:nth-last-child(1) {
    transition: opacity 0.5s ease-in 0.1s;
  }
  .srprs-header.is-lightweight.is-open .secure-overflow li:nth-last-child(2), .srprs-header.is-funnel.is-open .secure-overflow li:nth-last-child(2) {
    transition: opacity 0.5s ease-in 0.2s;
  }
  .srprs-header.is-lightweight.is-open .secure-overflow li:nth-last-child(3), .srprs-header.is-funnel.is-open .secure-overflow li:nth-last-child(3) {
    transition: opacity 0.5s ease-in 0.3s;
  }
  .srprs-header.is-lightweight.is-open .secure-overflow li:nth-last-child(4), .srprs-header.is-funnel.is-open .secure-overflow li:nth-last-child(4) {
    transition: opacity 0.5s ease-in 0.4s;
  }
  .srprs-header.is-lightweight.is-open .secure-overflow li:nth-last-child(5), .srprs-header.is-funnel.is-open .secure-overflow li:nth-last-child(5) {
    transition: opacity 0.5s ease-in 0.5s;
  }
  .srprs-header.is-lightweight.is-open .secure-overflow li:nth-last-child(6), .srprs-header.is-funnel.is-open .secure-overflow li:nth-last-child(6) {
    transition: opacity 0.5s ease-in 0.6s;
  }
  .srprs-header.is-lightweight.is-open .secure-overflow li:nth-last-child(7), .srprs-header.is-funnel.is-open .secure-overflow li:nth-last-child(7) {
    transition: opacity 0.5s ease-in 0.7s;
  }
  .srprs-header.is-lightweight.is-open .secure-overflow li:nth-last-child(8), .srprs-header.is-funnel.is-open .secure-overflow li:nth-last-child(8) {
    transition: opacity 0.5s ease-in 0.8s;
  }
  .srprs-header.is-lightweight.is-open .secure-overflow li:nth-last-child(9), .srprs-header.is-funnel.is-open .secure-overflow li:nth-last-child(9) {
    transition: opacity 0.5s ease-in 0.9s;
  }
  .srprs-header.is-lightweight.is-open .overlay, .srprs-header.is-funnel.is-open .overlay {
    visibility: hidden;
    opacity: 0;
  }
  .srprs-header.is-lightweight.is-open .srprs-button {
    transform: translateY(-50%);
  }
  .srprs-header.is-funnel .srprs-button {
    display: none;
  }
  .srprs-header.is-solid {
    box-shadow: 0 0 12px 0 rgba(34, 34, 34, 0.15);
  }
  .srprs-header.is-solid .logo {
    height: 39px;
    top: 18px;
  }
  .srprs-header.is-solid .logo .logo-smalldisplays {
    height: 39px;
    display: inline-block;
  }
  .srprs-header.is-solid .logo .logo-bigdisplays {
    display: none;
  }
  .srprs-header.is-solid .hamburger {
    transform: translateY(-50%);
  }
  .srprs-header.is-solid .hamburger:after {
    background-color: #222;
  }
  .srprs-header.is-solid .hamburger .bar {
    background-color: #222;
  }
  .srprs-header.is-solid .hamburger .bar:before, .srprs-header.is-solid .hamburger .bar:after {
    background-color: #222;
  }
  .srprs-header.no-menu .wrapper-desktop,
  .srprs-header.no-menu .hamburger {
    display: none;
  }
  .srprs-header .logo {
    width: 157px;
    height: 77px;
    top: 36px;
    left: 34px;
  }
  .srprs-header .logo .logo-smalldisplays {
    display: none;
  }
  .srprs-header .logo .logo-bigdisplays {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./../srprsme-react-components/src/components/_Assets/scss/_core.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/_helpers.scss","webpack://./../srprsme-react-components/src/components/Header/Header.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_breakpoint.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_browser-fixes.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/animations/_Button.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/vendor/animations/attention_seekers/_tada.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/repeatables/_iphonex.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/repeatables/_box-shadow.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_transition.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_truncate.scss"],"names":[],"mappings":"AAEA;;;;;;;;;;;CAAA;ACAA;EACE,cAAA;ACWF;;ADRA;EACE,eAAA;ACWF;ADVE;EAFF;IAGI,aAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADTE;EADF;IAEI,WAAA;ECaF;AACF;;ADTE;EADF;IAEI,UAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADVA;EACE,YAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADVA;EACE,gBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADXA;EACE,eAAA;ACcF;;ADZA;EACE,eAAA;ACeF;;ADbA;EACE,eAAA;ACgBF;;ADdA;EACE,eAAA;ACiBF;;ADfA;EACE,yBAAA;ACkBF;;ADfA;;EAEE,cAAA;EACA,yBAAA;ACkBF;ADjBE;;;EAEE,mBAAA;ACoBJ;;ACpFA;EAEI;IACE,iBAAA;IACA,aAAA;EDsFJ;AACF;ACvHI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDoEN;AACF;AC7HI;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED0EN;AACF;ACnII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDgFN;AACF;ACzII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDsFN;AACF;AC/II;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED4FN;AACF;ACrJI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDkGN;AACF;AC3JI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDwGN;AACF;AEzIA;;;;;;;;;;;;;;;CAAA;AChCA;EACE;IAEE,kCAAA;EH0LF;EGxLA;IAEE,iCAAA;EHyLF;EGvLA;IAGE,kCAAA;EHuLF;EGrLA;IAEE,iCAAA;EHsLF;AACF;AIzMA;EACE;IACE,2BAAA;EJ2MF;EIxMA;IAEE,0DAAA;EJyMF;EItMA;IAIE,yDAAA;EJqMF;EIlMA;IAGE,0DAAA;EJkMF;EI/LA;IACE,2BAAA;EJiMF;AACF;AI9LA;EACE,oBAAA;AJgMF;;AAxNA;EAGE,6BAAA;EACA,kBAAA;EACA,yCAAA;EAEA,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EAEE,6BAAA;EAEF,2CAAA;EACA,iBAAA;EASA,8CAAA;EAkKA,gBAAA;EAuSA,qDAAA;EAEA,4EAAA;EAWA,oDAAA;EAQA,8DAAA;EAqCA,oDAAA;EAiFA,cAAA;AA/XF;AKlPE;ELGF;IKDM,kDAAA;IACA,oDAAA;ELoPJ;AACF;AAlOE;EACE,aAAA;EACA,mBAAA;AAoOJ;AA9NE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;EACA,8BAAA;AAgOJ;AA/NI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EAEE,kBAAA;EAEF,2EAAA;AA+NN;AA5NM;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,wBAAA;AA8NR;AA7NQ;EACE,WAAA;AA+NV;AA5NQ;EACE,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AA8NV;AA7NU;EAEE,WAAA;EACA,kBAAA;EACA,SAAA;EAEE,kBAAA;EAEF,UAAA;EACA,WAAA;EACA,iCAAA;EACA,iBAAA;EACA,mCAAA;AA4NZ;AA1NU;EACE,0CAAA;AA4NZ;AA1NU;EACE,4CAAA;AA4NZ;AAxNQ;EAEI,eAAA;EACA,kBAAA;EAGA,iBAAA;EACA,eAAA;AAuNZ;AApNQ;EAEI,eAAA;AAqNZ;AAnNU;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EAEE,yBAAA;AAoNd;AAhNQ;EACE,aAAA;EACA,uBAAA;EAEE,eAAA;EACA,mBAAA;AAiNZ;AA/MU;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EAEE,yBAAA;AAgNd;AA7MU;EAEI,kBAAA;EACA,iBAAA;EAGA,kBAAA;EAGA,iBAAA;AA0Md;AApMM;EMtIF,6CAAA;ENwII,sBAAA;EAEA,yEAAA;EAEA,iBAAA;AAoMR;AAlMU;EACE,WAAA;AAoMZ;AAjMY;EAEE,sBAAA;AAkMd;AAhMY;EACE,2CAAA;AAkMd;AAhMY;EACE,2CAAA;AAkMd;AA3LE;EO3KE,wBAAA;EACA,0BP2KoB;EO1KpB,oCAAA;EAEE,oBANqD;EP+KvD,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EAEE,wCAAA;EAEF,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,WAAA;AA8LJ;AA1LE;EACE,WAAA;EACA,8BAAA;EACA,kBAAA;AA4LJ;AA3LI;EACE,WAAA;EACA,YAAA;AA6LN;AA5LM;EACE,uBAAA;AA8LR;AA3LI;EACE,WAAA;EACA,YAAA;EAEE,kBAAA;AA4LR;AAvLE;EOlNE,wBAAA;EACA,yBPkNoB;EOjNpB,oCAAA;EAEE,oBANqD;EPsNvD,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EAEE,wCAAA;EAEF,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,UAAA;AA0LJ;AAxLE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;AA0LJ;AAzLI;EACE,8BAAA;EACA,sBAAA;AA2LN;AAzLI;EACE,aAAA;AA2LN;AAzLI;EACE,WAAA;EACA,YAAA;EACA,qBAAA;AA2LN;AAxLE;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AA0LJ;AAzLI;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AA2LN;AA1LM;EACE,cAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EAEE,kBAAA;EAGA,2BAAA;EACA,8BAAA;EAGA,kCAAA;AAuLV;AArLQ;EAEE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,oBAAA;EAEE,2BAAA;EACA,8BAAA;EAGA,kCAAA;AAmLZ;AAhLQ;EACE,YAAA;EACA,SAAA;EACA,WAAA;EACA,0GAAA;AAkLV;AA/KQ;EACE,YAAA;EACA,YAAA;EACA,WAAA;EACA,6GAAA;AAiLV;AAxKI;EO3TA,wBAAA;EACA,0BP2TsB;EO1TtB,oCAAA;EAEE,oBANqD;EPgUrD,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EAEE,sBAAA;EAGA,oBAAA;EAEF,kBAAA;EACA,UAAA;AAwKN;AAtKM;EACE,aAAA;EACA,YAAA;EACA,WAAA;AAwKR;AAvKQ;EACE,UAAA;AAyKV;AAtKQ;EAEI,gBAAA;EACA,iBAAA;AAuKZ;AApKY;EACE,WAAA;AAsKd;AApKY;;EAEE,sBAAA;AAsKd;AAlKQ;EACE,gBAAA;AAoKV;AAhKQ;EAEI,mBAAA;AAiKZ;AA9JU;EO9WN,wBAAA;EACA,0BP8W4B;EO7W5B,oCAAA;EAEE,oBANqD;ECCzD,gBAAA;EACA,mBAAA;EACA,uBAAA;ERgXU,cAAA;EACA,UAAA;EAEE,iBAAA;EACA,0CAAA;EACA,2CAAA;EACA,oBAAA;EAEF,iBAAA;EACA,yBAAA;EAEE,eAAA;EACA,mBAAA;EACA,2IAAA;AAkKd;AA/JY;EACE,WAAA;AAiKd;AA9JY;EAEI,sDAAA;EAIE,sBAAA;EACA,wBAAA;EACA,uBAAA;AA4JlB;AArJM;EAEI,0CAAA;EAEF,4BAAA;EACA,WAAA;AAqJR;AA/IE;EACE,0CAAA;EACA,aAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,qBAAA;AAiJJ;AA/II;EACE,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;AAiJN;AAhJM;EACE,qBAAA;EACA,yBAAA;EAEE,2IAAA;EACA,mBAAA;EACA,eAAA;EAGA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AA+IV;AA7IQ;EACE,wBAAA;AA+IV;AA5IQ;EACE,iBAAA;EAEE,qBAAA;EACA,uBAAA;EACA,mCAAA;AA6IZ;AAzIM;EOvcF,wBAAA;EACA,0BPucwB;EOtcxB,oCAAA;EAEE,oBANqD;EP4cnD,WAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EAEE,8CAAA;EAGA,+BAAA;EACA,8BAAA;AA0IV;AArII;EACE,kBAAA;AAuIN;AArII;EACE,oBAAA;EACA,eAAA;EACA,0BAAA;AAuIN;AA/HI;EACE,WAAA;AAiIN;AA/HI;EACE,mBAAA;EACA,UAAA;AAiIN;AA5HE;EACE,kBAAA;AA8HJ;AA7HI;EACE,aAAA;AA+HN;AA1HE;EACE,iBAAA;EAEE,sBAAA;AA2HN;AAxHI;EACE,kBAAA;AA0HN;AAvHU;EACE,aAAA;EAEE,yBAAA;AAwHd;AApHQ;EACE,iBAAA;AAsHV;AArHU;EACE,iBAAA;AAuHZ;AAnHM;EACE,WAAA;EAEE,sBAAA;EAGA,kBAAA;AAkHV;AA1GI;EACE,mBAAA;EACA,UAAA;AA4GN;AAzGI;EACE,iBAAA;AA2GN;AA1GM;EACE,mBAAA;EACA,UAAA;AA4GR;AA3GQ;EACE,UAAA;AA6GV;AA3GY;EACE,sEAAA;AA6Gd;AA9GY;EACE,sEAAA;AAgHd;AAjHY;EACE,sEAAA;AAmHd;AApHY;EACE,sEAAA;AAsHd;AAvHY;EACE,sEAAA;AAyHd;AA1HY;EACE,sEAAA;AA4Hd;AA7HY;EACE,sEAAA;AA+Hd;AAhIY;EACE,sEAAA;AAkId;AAnIY;EACE,sEAAA;AAqId;AAtIY;EACE,kEAAA;AAwId;AAzIY;EACE,sEAAA;AA2Id;AA5IY;EACE,sEAAA;AA8Id;AA/IY;EACE,sEAAA;AAiJd;AAlJY;EACE,sEAAA;AAoJd;AArJY;EACE,sEAAA;AAuJd;AAxJY;EACE,sEAAA;AA0Jd;AA3JY;EACE,sEAAA;AA6Jd;AA9JY;EACE,sEAAA;AAgKd;AAjKY;EACE,sEAAA;AAmKd;AA9JQ;EACE,wBAAA;AAgKV;AA9JY;EACE,uBAAA;AAgKd;AAjKY;EACE,sBAAA;AAmKd;AApKY;EACE,uBAAA;AAsKd;AAvKY;EACE,sBAAA;AAyKd;AA1KY;EACE,uBAAA;AA4Kd;AA7KY;EACE,sBAAA;AA+Kd;AAhLY;EACE,uBAAA;AAkLd;AAnLY;EACE,sBAAA;AAqLd;AAtLY;EACE,uBAAA;AAwLd;AAzLY;EACE,sBAAA;AA2Ld;AA5LY;EACE,uBAAA;AA8Ld;AA/LY;EACE,sBAAA;AAiMd;AAlMY;EACE,uBAAA;AAoMd;AArMY;EACE,sBAAA;AAuMd;AAxMY;EACE,uBAAA;AA0Md;AA3MY;EACE,sBAAA;AA6Md;AA9MY;EACE,uBAAA;AAgNd;AAjNY;EACE,sBAAA;AAmNd;AApNY;EACE,uBAAA;AAsNd;AA/MM;EACE,UAAA;EACA,wBAAA;AAiNR;AA/MU;EACE,sEAAA;AAiNZ;AAlNU;EACE,sEAAA;AAoNZ;AArNU;EACE,sEAAA;AAuNZ;AAxNU;EACE,sEAAA;AA0NZ;AA3NU;EACE,sEAAA;AA6NZ;AA9NU;EACE,sEAAA;AAgOZ;AAjOU;EACE,sEAAA;AAmOZ;AApOU;EACE,sEAAA;AAsOZ;AAvOU;EACE,sEAAA;AAyOZ;AA1OU;EACE,kEAAA;AA4OZ;AA7OU;EACE,sEAAA;AA+OZ;AAhPU;EACE,sEAAA;AAkPZ;AAnPU;EACE,sEAAA;AAqPZ;AAtPU;EACE,sEAAA;AAwPZ;AAzPU;EACE,sEAAA;AA2PZ;AA5PU;EACE,sEAAA;AA8PZ;AA/PU;EACE,sEAAA;AAiQZ;AAlQU;EACE,sEAAA;AAoQZ;AArQU;EACE,sEAAA;AAuQZ;AAhQM;EAEI,6BAAA;AAiQV;AA/PQ;EACE,MAAA;EACA,wBAAA;EACA,0GAAA;EAGE,4BAAA;EACA,+BAAA;AA+PZ;AA5PQ;EACE,WAAA;EACA,SAAA;EACA,yBAAA;EACA,6GAAA;EAGE,2BAAA;EACA,8BAAA;AA4PZ;AArPE;EACE,gBAAA;EACA,kBAAA;AAuPJ;AAtPI;EACE,aAAA;AAwPN;AAnPE;EACE,kBAAA;EACA,iBAAA;AAqPJ;AApPI;EACE,kBAAA;AAsPN;AAnPE;EACE,kBAAA;EACA,iBAAA;AAqPJ;AApPI;EACE,kBAAA;AAsPN;;AC/2BI;ED+nBA;IACE,qBAAA;EAoPJ;AACF;ACr3BI;EDsoBF;IAaE,4KAAA;IAgDA,+HAAA;IAcA,8DAAA;IA8CA,kBAAA;EA6HF;EArPE;IACE,aAAA;EAuPJ;EApPE;IACE,aAAA;EAsPJ;EArPI;IACE,kBAAA;IACA,UAAA;EAuPN;EAhPI;IACE,mBAAA;IACA,UAAA;EAkPN;EA/OM;IACE,kBAAA;IACA,UAAA;EAiPR;EA9OI;IAEI,kBAAA;IACA,cAAA;EA+OR;EA5OI;IACE,kBAAA;IACA,MAAA;IACA,QAAA;EA8ON;EA1OM;IACE,mBAAA;IACA,UAAA;EA4OR;EAzOQ;IACE,mBAAA;IACA,UAAA;EA2OV;EAzOY;IACE,qCAAA;EA2Od;EA5OY;IACE,qCAAA;EA8Od;EA/OY;IACE,qCAAA;EAiPd;EAlPY;IACE,qCAAA;EAoPd;EArPY;IACE,qCAAA;EAuPd;EAxPY;IACE,qCAAA;EA0Pd;EA3PY;IACE,qCAAA;EA6Pd;EA9PY;IACE,qCAAA;EAgQd;EAjQY;IACE,qCAAA;EAmQd;EA9PM;IACE,kBAAA;IACA,UAAA;EAgQR;EAxPM;IACE,2BAAA;EA0PR;EArPI;IACE,aAAA;EAuPN;EAhPE;IM5sBA,6CAAA;EN+7BF;EAhPI;IACE,YAAA;IACA,SAAA;EAkPN;EAjPM;IACE,YAAA;IACA,qBAAA;EAmPR;EAjPM;IACE,aAAA;EAmPR;EAhPI;IACE,2BAAA;EAkPN;EAhPM;IAEI,sBAAA;EAiPV;EA9OM;IAEI,sBAAA;EA+OV;EA7OQ;IAGI,sBAAA;EA6OZ;EArOI;;IAEE,aAAA;EAuON;EAlOE;IACE,YAAA;IACA,YAAA;IACA,SAAA;IACA,UAAA;EAoOJ;EAnOI;IACE,aAAA;EAqON;EAnOI;IACE,cAAA;EAqON;AACF","sourcesContent":["@charset \"UTF-8\";\n\n/*\n\tFILE: _core.scss\n\n\tUSED ON:\n\t\t- srprs.me/*\n\n\tUSAGE:\n\t\tMeant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1\n\n\tNOTES:\n\t\tNEVER use @import \"base/*\"; or such, read this => http://stackoverflow.com/a/4779432\n*/\n\n// vars & helpers\n@import 'helpers/variables';\n@import 'helpers/helpers';\n\n// functions\n@import 'helpers/functions/map-deep-get';\n@import 'helpers/functions/color';\n@import 'helpers/functions/font';\n//@import \"helpers/functions/padding\";\n@import 'helpers/functions/section';\n@import 'helpers/functions/str-replace';\n@import 'helpers/functions/z-index';\n\n// mixins\n@import 'helpers/mixins/arrow';\n@import 'helpers/mixins/aspect-ratio';\n@import 'helpers/mixins/breakpoint';\n@import 'helpers/mixins/browser-fixes';\n@import 'helpers/mixins/color-schemes';\n@import 'helpers/mixins/grid';\n@import 'helpers/mixins/no-bullets';\n@import 'helpers/mixins/clearfix';\n@import 'helpers/mixins/font-face';\n@import 'helpers/mixins/scrollbars';\n@import 'helpers/mixins/transform-center';\n@import 'helpers/mixins/transition';\n@import 'helpers/mixins/truncate';\n\n// repeatables (aka think DRY and store it in an @mixin)\n@import 'helpers/repeatables/box-shadow';\n@import 'helpers/repeatables/iphonex';\n@import 'helpers/repeatables/wrapper-inner';\n\n// animations\n@import 'animations/Button';\n","@charset \"UTF-8\";\n\n.clearfix {\n  overflow: auto;\n}\n\n.display-flex {\n  display: inline;\n  @media only screen and (min-width: 767px) {\n    display: flex;\n  }\n}\n\n.full-width {\n  width: 100%;\n}\n\n.mobile-full-width {\n  @media only screen and (max-width: 767px) {\n    width: 100%;\n  }\n}\n\n.width-49 {\n  @media only screen and (min-width: 767px) {\n    width: 49%;\n  }\n}\n\n.pull-left {\n  float: left;\n}\n\n.pull-right {\n  float: right;\n}\n\n.margin-b-s {\n  margin-bottom: 10px;\n}\n\n.margin-b-m {\n  margin-bottom: 20px;\n}\n\n.margin-b-l {\n  margin-bottom: 40px;\n}\n\n.padding-t-s {\n  padding-top: 10px;\n}\n\n.padding-t-s-7 {\n  padding-top: 7px;\n}\n\n.padding-l-s {\n  padding-left: 10px;\n}\n\n.padding-r-s {\n  padding-right: 10px;\n}\n\n.padding-r-m {\n  padding-right: 20px;\n}\n\n.padding-r-xl {\n  padding-right: 60px;\n}\n\n.text-centered {\n  text-align: center;\n}\n\n.text-bold {\n  font-weight: bold;\n}\n.text-small {\n  font-size: 14px;\n}\n.text-medium {\n  font-size: 20px;\n}\n.text-large {\n  font-size: 24px;\n}\n.text-xlarge {\n  font-size: 28px;\n}\n.text-uppercase {\n  text-transform: uppercase;\n}\n\n.is-loading,\n.loading {\n  color: #ececec;\n  background-color: #ececec;\n  &::selection,\n  &::-moz-selection {\n    background: #ececec;\n  }\n}\n","@charset \"UTF-8\";\n\n@import '../_Assets/scss/core';\n@import '../_Assets/scss/vendor/animations/attention_seekers/tada';\n\n.srprs-header {\n  @include iphonex();\n\n  --mobileMenuPaddingLeft: 40px;\n  --menuColour: #{color(black)};\n  --topColour: var(--colorForegroundAccent);\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: z-index(header);\n  width: 100vw;\n  height: 71px;\n  background: {\n    color: transparent;\n  }\n  transition: background-color 0.25s ease-out;\n  will-change: auto;\n\n  > .wrapper-inner {\n    display: flex;\n    align-items: center;\n  }\n\n  // Generic for both options\n\n  /* locale related stuff (the fancy dropdown) */\n  .locale {\n    position: relative;\n    height: 36px;\n    width: 96px;\n    z-index: 12;\n    text-transform: uppercase;\n    transition: all 0.15s ease-out;\n    .locale-dropdown {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 96px;\n      max-height: 36px;\n      overflow: hidden;\n      text-align: center;\n      border: {\n        radius: 4px;\n      }\n      transition: background-color 0.15s ease-in 0.25s,\n        max-height 0.25s ease-out;\n\n      li {\n        position: relative;\n        line-height: 36px;\n        cursor: pointer;\n        color: var(--menuColour);\n        a {\n          color: color(black);\n        }\n\n        .chevron {\n          display: inline-block;\n          margin-left: 4px;\n          width: 12px;\n          height: 100%;\n          &:before,\n          &:after {\n            content: '';\n            position: absolute;\n            top: 14px;\n            border: {\n              radius: 2px;\n            }\n            width: 2px;\n            height: 6px;\n            transition: all 0.25s ease-in-out;\n            will-change: auto;\n            background-color: var(--menuColour);\n          }\n          &:before {\n            transform: translate(2px, 0) rotate(45deg);\n          }\n          &:after {\n            transform: translate(-2px, 0) rotate(-45deg);\n          }\n        }\n\n        &.locale-currentLanguage {\n          margin: {\n            top: 4px;\n            bottom: 9px;\n          }\n          font: {\n            weight: bold;\n            size: 16px;\n          }\n        }\n        &.locale-line {\n          margin: {\n            top: 9px;\n          }\n          &:before {\n            content: '';\n            position: absolute;\n            top: -4px;\n            left: 20%;\n            width: 60%;\n            height: 1px;\n            background: {\n              color: color(grey-light);\n            }\n          }\n        }\n        &.locale-currency {\n          display: flex;\n          justify-content: center;\n          margin: {\n            top: 9px;\n            bottom: 12px;\n          }\n          &:before {\n            content: '';\n            position: absolute;\n            top: -4px;\n            left: 20%;\n            width: 60%;\n            height: 1px;\n            background: {\n              color: color(grey-light);\n            }\n          }\n          a {\n            padding: {\n              right: 8px;\n              left: 8px;\n            }\n            margin: {\n              right: -4px;\n            }\n            font: {\n              weight: bold;\n            }\n          }\n        }\n      }\n\n      &.is-open {\n        @include box-shadow();\n        background-color: color(white);\n\n        transition: background-color 0.15s ease-out 0s,\n          max-height 0.25s ease-out;\n        max-height: 340px;\n        li {\n          span {\n            color: color(black);\n          }\n          .chevron {\n            &:before,\n            &:after {\n              background-color: color(black);\n            }\n            &:before {\n              transform: translate(-2px, 0) rotate(45deg);\n            }\n            &:after {\n              transform: translate(2px, 0) rotate(-45deg);\n            }\n          }\n        }\n      }\n    }\n  }\n  .locale-overlay {\n    @include transition(0.25s);\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    overflow-x: hidden;\n    overflow-y: auto;\n    background: {\n      color: rgba(color(black), 0.95);\n    }\n    visibility: hidden;\n    opacity: 0;\n    user-select: none;\n    z-index: 11;\n  }\n\n  /* login stuff */\n  .login {\n    z-index: 12;\n    transition: all 0.25s ease-out;\n    margin-left: -10px;\n    svg {\n      width: 24px;\n      height: 24px;\n      path {\n        fill: var(--menuColour);\n      }\n    }\n    .avatar {\n      width: 24px;\n      height: 24px;\n      border: {\n        radius: 50%;\n      }\n    }\n  }\n\n  .overlay {\n    @include transition(0.5s);\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    overflow-x: hidden;\n    overflow-y: auto;\n    background: {\n      color: rgba(color(black), 0.95);\n    }\n    visibility: hidden;\n    opacity: 0;\n    user-select: none;\n    z-index: 0;\n  }\n  .logo {\n    width: 40px;\n    height: 35px;\n    position: absolute;\n    top: 18px;\n    left: 18px;\n    visibility: visible;\n    path {\n      transition: all 0.25s ease-out;\n      fill: var(--topColour);\n    }\n    .logo-bigdisplays {\n      display: none;\n    }\n    > a {\n      width: 100%;\n      height: 100%;\n      display: inline-block;\n    }\n  }\n  .hamburger-wrapper {\n    position: absolute;\n    display: flex;\n    top: 26px;\n    right: 20px;\n    width: 30px;\n    height: 30px;\n    .hamburger {\n      /* nomnomnom */\n      position: absolute;\n      z-index: 11;\n      top: 0;\n      right: 0;\n      width: 30px;\n      height: 30px;\n      cursor: pointer;\n      .bar {\n        display: block;\n        position: absolute;\n        right: 0;\n        top: 9px;\n        width: 30px;\n        height: 5px;\n        margin: {\n          bottom: 4px;\n        }\n        border: {\n          top-left-radius: 5px;\n          bottom-left-radius: 5px;\n        }\n        background: {\n          color: var(--topColour);\n        }\n        &:before,\n        &:after {\n          content: '';\n          position: absolute;\n          right: 0;\n          height: 5px;\n          transform: rotate(0);\n          border: {\n            top-left-radius: 3px;\n            bottom-left-radius: 3px;\n          }\n          background: {\n            color: var(--topColour);\n          }\n        }\n        &:before {\n          /* 1st bar */\n          top: -9px;\n          width: 32px;\n          transition: top 0.25s 0.25s cubic-bezier(0.23, 1, 0.32, 1),\n            transform 0.25s cubic-bezier(0.23, 1, 0.32, 1);\n        }\n        &:after {\n          /* 3rd bar */\n          bottom: -9px;\n          width: 24px;\n          transition: bottom 0.25s 0.25s cubic-bezier(0.23, 1, 0.32, 1),\n            transform 0.25s cubic-bezier(0.23, 1, 0.32, 1);\n        }\n      }\n    }\n  }\n\n  // Mobile\n  .wrapper-mobile {\n    .wrapper-menu {\n      @include transition(0.25s);\n\n      position: fixed;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: auto;\n      z-index: 10;\n      background: {\n        color: color(white);\n      }\n      padding: {\n        bottom: 40px;\n      }\n      visibility: hidden;\n      opacity: 0;\n\n      .wrapper-header {\n        display: flex;\n        height: 84px;\n        color: color(black);\n        path {\n          fill: color(black);\n        }\n\n        .locale {\n          margin: {\n            top: 14px;\n            left: 10px;\n          }\n          .locale-dropdown {\n            li {\n              color: color(black);\n            }\n            .chevron:before,\n            .chevron:after {\n              background-color: color(black);\n            }\n          }\n        }\n        .login {\n          margin-top: 24px;\n        }\n      }\n      .wrapper-content {\n        ul {\n          margin: {\n            bottom: 22px;\n          }\n\n          li {\n            @include transition(0.15s);\n            @include truncate();\n            display: block;\n            opacity: 0;\n            padding: {\n              top: 12px;\n              left: var(--mobileMenuPaddingLeft);\n              right: var(--mobileMenuPaddingLeft);\n              bottom: 12px;\n            }\n            line-height: 20px;\n            text-transform: uppercase;\n            font: {\n              size: 16px;\n              weight: normal;\n              family: font(heading);\n            }\n\n            a {\n              color: color(black);\n            }\n\n            &.is-current {\n              padding: {\n                left: calc(var(--mobileMenuPaddingLeft) - 5px);\n              }\n              border: {\n                left: {\n                  width: 5px;\n                  style: solid;\n                  color: color(black);\n                }\n              }\n            }\n          }\n        }\n      }\n      .srprs-button {\n        padding: {\n          left: var(--mobileMenuPaddingLeft);\n        }\n        transform: translateX(-100%);\n        color: color(white);\n      }\n    }\n  }\n\n  // Desktop\n  .wrapper-desktop {\n    --menuColour: var(--colorForegroundAccent);\n    display: none;\n    position: absolute;\n    top: 0;\n    right: 0;\n    align-items: flex-end;\n\n    .secure-overflow {\n      position: relative;\n      display: flex;\n      align-items: flex-end;\n      margin-right: 20px;\n      li {\n        display: inline-block;\n        text-transform: uppercase;\n        font: {\n          family: font(heading);\n          weight: normal;\n          size: 15px;\n        }\n        padding: {\n          top: 70px;\n          right: 15px;\n          bottom: 0;\n          left: 15px;\n        }\n        a {\n          color: var(--menuColour);\n        }\n\n        &.is-current {\n          padding-top: 62px;\n          border-top: {\n            width: 8px;\n            style: solid;\n            color: var(--menuColour);\n          }\n        }\n      }\n      &:after {\n        @include transition(0.25s);\n\n        content: '';\n        position: absolute;\n        bottom: -8px;\n        right: -18px;\n        width: 6px;\n        height: 48px;\n        background: {\n          color: var(--colorForegroundAccent);\n        }\n        border: {\n          bottom-right-radius: 6px;\n          bottom-left-radius: 6px;\n        }\n      }\n    }\n\n    .login {\n      margin-right: 40px;\n    }\n    .srprs-button {\n      margin-bottom: -10px;\n      transform: none;\n      text-transform: capitalize;\n    }\n  }\n\n  /* STATES - DON'T RE-ORDER STUFF OR ELSE I WILL CRY */\n\n  /* states => locked when the visitor clicks the language/currency dropdown */\n  &.is-locked {\n    .login {\n      z-index: 10;\n    }\n    .locale-overlay {\n      visibility: visible;\n      opacity: 1;\n    }\n  }\n\n  /* states => is in funnel, no need to show the CTA */\n  &.is-funnel {\n    position: absolute;\n    .srprs-button {\n      display: none;\n    }\n  }\n\n  /* states => solid (solid bg after scrolling page for ~20px) */\n  &.is-solid {\n    --topColour: #{color(black)};\n    background: {\n      color: color(white);\n    }\n\n    .wrapper-desktop {\n      --menuColour: #{color(black)};\n      .secure-overflow {\n        ul {\n          &:after {\n            margin-top: 0;\n            background: {\n              color: color(grey-light);\n            }\n          }\n        }\n        li {\n          padding-top: 25px;\n          &.is-current {\n            padding-top: 20px;\n          }\n        }\n      }\n      .srprs-button {\n        color: color(white);\n        background: {\n          color: color(black);\n        }\n        border: {\n          color: color(black);\n        }\n      }\n    }\n  }\n\n  /* states => when the visitor clicks the hamburger */\n  &.is-open {\n    .overlay {\n      visibility: visible;\n      opacity: 1;\n    }\n\n    .wrapper-mobile {\n      --topColour: #{color(black)};\n      .wrapper-menu {\n        visibility: visible;\n        opacity: 1;\n        .wrapper-content ul li {\n          opacity: 1;\n          @for $i from 1 to 20 {\n            &:nth-child(#{$i}) {\n              transition: opacity 0.15s ease-out $i * 0.1s,\n                transform 0.15s ease-out $i * 0.1s;\n            }\n          }\n        }\n        .srprs-button {\n          transform: translateX(0);\n          @for $i from 1 to 20 {\n            &.is-followup-#{$i + 1} {\n              transition-delay: $i * 0.15s;\n            }\n          }\n        }\n      }\n    }\n    .wrapper-desktop {\n      .secure-overflow li {\n        opacity: 1;\n        transform: translateY(0);\n        @for $i from 1 to 20 {\n          &:nth-child(#{$i}) {\n            transition: opacity 0.15s ease-out $i * 0.1s,\n              transform 0.15s ease-out $i * 0.1s;\n          }\n        }\n      }\n    }\n    .hamburger {\n      .bar {\n        background: {\n          color: transparent;\n        }\n        &:before {\n          top: 0;\n          transform: rotate(45deg);\n          transition: top 0.25s cubic-bezier(0.23, 1, 0.32, 1),\n            transform 0.25s 0.25s cubic-bezier(0.23, 1, 0.32, 1);\n          border: {\n            top-right-radius: 5px;\n            bottom-right-radius: 5px;\n          }\n        }\n        &:after {\n          width: 32px;\n          bottom: 0;\n          transform: rotate(-45deg);\n          transition: bottom 0.25s cubic-bezier(0.23, 1, 0.32, 1),\n            transform 0.25s 0.25s cubic-bezier(0.23, 1, 0.32, 1);\n          border: {\n            top-left-radius: 5px;\n            bottom-left-radius: 5px;\n          }\n        }\n      }\n    }\n  }\n\n  &.no-menu {\n    background: none;\n    position: absolute;\n    .hamburger {\n      display: none;\n    }\n  }\n\n  /* Overrides */\n  &.override-black {\n    --menuColour: #{color(black)};\n    --topColour: #{color(black)};\n    .wrapper-desktop {\n      --menuColour: #{color(black)};\n    }\n  }\n  &.override-white:not(.is-solid) {\n    --menuColour: #{color(white)};\n    --topColour: #{color(white)};\n    .wrapper-desktop {\n      --menuColour: #{color(white)};\n    }\n  }\n}\n@include breakpoint(tablet-landscape) {\n  .srprs-header {\n    &.is-funnel {\n      margin-bottom: -140px; // Compensate for position relative instead of fixed\n    }\n  }\n}\n\n@include breakpoint(desktop) {\n  .srprs-header {\n    .wrapper-mobile {\n      display: none;\n    }\n\n    .wrapper-desktop {\n      display: flex;\n      .hamburger {\n        visibility: hidden;\n        opacity: 0;\n      }\n    }\n\n    /* states => lightweight/funnel - disable 'book now' button (and move all other stuff to the right) + some extra styles for .is-lightweight (we like to keep stuff DRY ;)) */\n    &.is-lightweight,\n    &.is-funnel {\n      .hamburger {\n        visibility: visible;\n        opacity: 1;\n      }\n      .secure-overflow {\n        li {\n          visibility: hidden;\n          opacity: 0;\n        }\n      }\n      .login {\n        margin: {\n          right: 50px;\n          left: 0;\n        }\n      }\n      .hamburger-wrapper {\n        position: relative;\n        top: 0;\n        right: 0;\n      }\n\n      &.is-open {\n        .logo {\n          visibility: visible;\n          opacity: 1;\n        }\n        .secure-overflow {\n          li {\n            visibility: visible;\n            opacity: 1;\n            @for $i from 1 to 10 {\n              &:nth-last-child(#{$i}) {\n                transition: opacity 0.5s ease-in $i * 0.1s;\n              }\n            }\n          }\n        }\n        .overlay {\n          visibility: hidden;\n          opacity: 0;\n        }\n      }\n    }\n\n    /* states => lightweight variant means \"menu-items hidden behind hamburger menu, which means less distraction for the visitor */\n    &.is-lightweight {\n      &.is-open {\n        .srprs-button {\n          transform: translateY(-50%);\n        }\n      }\n    }\n    &.is-funnel {\n      .srprs-button {\n        display: none;\n      }\n    }\n\n    /* states => solid (solid bg after scrolling page for ~20px) */\n    // &:hover,\n    // &.is-open,\n    &.is-solid {\n      @include box-shadow();\n\n      .logo {\n        height: 39px;\n        top: 18px;\n        .logo-smalldisplays {\n          height: 39px;\n          display: inline-block;\n        }\n        .logo-bigdisplays {\n          display: none;\n        }\n      }\n      .hamburger {\n        transform: translateY(-50%);\n\n        &:after {\n          background: {\n            color: color(black);\n          }\n        }\n        .bar {\n          background: {\n            color: color(black);\n          }\n          &:before,\n          &:after {\n            background: {\n              color: color(black);\n            }\n          }\n        }\n      }\n    }\n\n    &.no-menu {\n      .wrapper-desktop,\n      .hamburger {\n        display: none;\n      }\n    }\n\n    /* GENERIC STUFF */\n    .logo {\n      width: 157px;\n      height: 77px;\n      top: 36px;\n      left: 34px;\n      .logo-smalldisplays {\n        display: none;\n      }\n      .logo-bigdisplays {\n        display: block;\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n$breakpoints: map-deep-get($srprsreactwebsite-config, 'breakpoints');\n\n@mixin breakpoint($screensize) {\n  @if map-has-key($breakpoints, $screensize) {\n    @media screen and (min-width: map-get($breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (min-width: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$height-breakpoints: map-deep-get(\n  $srprsreactwebsite-config,\n  'height-breakpoints'\n);\n\n@mixin height-breakpoint($screensize) {\n  @if map-has-key($height-breakpoints, $screensize) {\n    @media screen and (max-height: map-get($height-breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (max-height: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$breakpoint-initial: map-deep-get(\n  $srprsreactwebsite-config,\n  'breakpoints',\n  's'\n);\n@media screen and (max-width: $breakpoint-initial) {\n  body {\n    &:before {\n      content: 'mobile';\n      display: none;\n    }\n  }\n}\n\n@each $breakpoint, $screensize in $breakpoints {\n  @include breakpoint(#{$screensize}) {\n    body {\n      &::before {\n        @if $breakpoint ==\n          l or\n          $breakpoint ==\n          xl or\n          $breakpoint ==\n          xxl or\n          $breakpoint ==\n          xxxl\n        {\n          content: 'desktop';\n        } @else if $breakpoint == m {\n          content: 'tablet';\n        } @else {\n          content: 'mobile';\n        }\n        display: none;\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n// we should thank http://browserhacks.com/ for this great roundup of dirt\n\n@mixin browserfix($browser) {\n  @if ($browser == 'ie') {\n    // the allmighty IE, 10 and up. 9 and lower requires usage of conditional comments, just stash your code in assets/styles/ie.scss\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      @content;\n    }\n  } @else if ($browser == 'firefox') {\n    // firefox 3 and up\n    @-moz-document url-prefix() {\n      @content;\n    }\n  } @else if ($browser == 'opera') {\n    // opera 9.5 and up\n    _:-o-prefocus,\n    body:last-child .selector {\n      @content;\n    }\n  } @else if ($browser == 'safari') {\n    // all safari\n    .selector:not(*:root) {\n      @content;\n    }\n  } @else if ($browser == 'chrome') {\n    // chrome 28 and up\n    @supports (-webkit-appearance: none) {\n      @content;\n    }\n  }\n}\n\n/*\n\tusage:\n\n\t.element {\n\t\t@include browserfix(ie) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"This is IE only\"\n\t\t\t}\n\t\t}\n\t\t@include browserfix(firefox) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"Only Firefox users will see this\";\n\t\t\t}\n\t\t}\n\t}\n*/\n","@charset \"UTF-8\";\n\n@keyframes buttonDisabled {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0);\n  }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0);\n  }\n}\n","@keyframes tada {\n  0% {\n    transform: scale3d(1, 1, 1);\n  }\n\n  10%,\n  20% {\n    transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);\n  }\n\n  30%,\n  50%,\n  70%,\n  90% {\n    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);\n  }\n\n  40%,\n  60%,\n  80% {\n    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);\n  }\n\n  100% {\n    transform: scale3d(1, 1, 1);\n  }\n}\n\n.tada {\n  animation-name: tada;\n}\n","@mixin iphonex {\n  // reference: https://forum.vuejs.org/t/getting-css-ready-for-iphone-x/25212/5\n  @supports (padding: max(0px)) {\n    padding: {\n      left: calc(constant(safe-area-inset-left));\n      right: calc(constant(safe-area-inset-right));\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n$box-shadow: map-deep-get($srprsreactwebsite-config, 'box-shadow');\n\n@mixin box-shadow(\n  $blur: map-deep-get($srprsreactwebsite-config, 'box-shadow', 'blur-default')\n) {\n  @if map-has-key($box-shadow, $blur) {\n    box-shadow: 0\n      0\n      map-deep-get($srprsreactwebsite-config, 'box-shadow', $blur)\n      0\n      rgba(color(black), 0.15);\n  } @else {\n    box-shadow: 0\n      0\n      map-deep-get($srprsreactwebsite-config, 'box-shadow', 'blur-default')\n      0\n      rgba(color(black), 0.15);\n  }\n}\n","@charset \"UTF-8\";\n\n@mixin transition($transition-duration, $transition-delay: 0s) {\n  transition: {\n    property: all;\n    duration: $transition-duration;\n    timing-function: ease-out;\n    @if $transition-delay {\n      delay: $transition-delay;\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n@mixin truncate() {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
